import { motion } from "framer-motion";
import { PhoneCall } from "lucide-react";
import { TAP } from "./motionPresets";

const Lumacofonata = ({ used, enabled, onClick }) => (
  <button
    type="button"
    data-testid="lumacofonata-btn"
    disabled={!enabled}
    onClick={onClick}
    className={`luma-btn w-full rounded-[26px] px-4 py-3 flex items-center gap-3 ${
      enabled ? "" : "opacity-50 cursor-not-allowed"
    }`}
  >
    <span className="w-10 h-10 rounded-full bg-gradient-to-br from-[#55D7F3] to-[#7433C1] flex items-center justify-center shrink-0">
      <PhoneCall size={18} className="text-white" />
    </span>
    <div className="text-left flex-1">
      <p className="font-display text-base text-[#14233D] tracking-wide">LUMACOFONATA</p>
      <p className="text-[11px] font-medium text-[#506780]">Rifiuta questa ciurma e rigira</p>
    </div>
    <span
      data-testid="lumacofonata-status"
      className={`label-mono text-[9px] px-2.5 py-1 rounded-full whitespace-nowrap shrink-0 ${
        used ? "bg-[#D9D2EE] text-[#7A7399]" : "bg-[#F26DB5] text-white"
      }`}
    >
      {used ? "Usata" : "1 sola volta"}
    </span>
  </button>
);

const SPIN_LABELS = { spinning: "· · ·", complete: "SI SALPA" };

export const ActionBar = ({ phase, rerollUsed, onSpin, onReroll }) => {
  const choosing = phase === "choose";
  return (
    <div className="fixed bottom-0 inset-x-0 z-30 action-bar">
      <div className="max-w-md mx-auto px-4 pt-3 pb-[max(1rem,env(safe-area-inset-bottom))]">
        {choosing ? (
          <Lumacofonata used={rerollUsed} enabled={!rerollUsed} onClick={onReroll} />
        ) : (
          <motion.button
            type="button"
            data-testid="spin-button"
            disabled={phase !== "ready"}
            onClick={onSpin}
            whileTap={TAP}
            className={`spin-btn w-full rounded-full font-display text-[2rem] tracking-[0.18em] text-white py-4 ${
              phase === "ready" ? "spin-ready" : "opacity-60"
            }`}
          >
            {SPIN_LABELS[phase] ?? "SPIN"}
          </motion.button>
        )}
      </div>
    </div>
  );
};
